import { APICallV3Post } from 'reactApp/api/APICall';

export class BindCreateAPICall extends APICallV3Post {
    _method = 'billing/bind/create';
}
